import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { wsGetAll } from 'services/WService';

export const LayerContext = createContext({
  // Divisiones
  divitions: [],
  selectedDivition: undefined,
  setSelectedDivition: () => {},
  excludedDivitions: [],
  setExcludedDivitions: () => {},
  filteredDivitions: [],
  // Capas
  layers: [],
  selectedLayer: undefined,
  setSelectedLayer: () => {},
  filteredLayers: [],
});

export const LayerProvider = ({ children }) => {
  const [divitions, setDivitions] = useState([]);
  const [excludedDivitions, setExcludedDivitions] = useState([]);
  const [selectedDivition, setSelectedDivition] = useState();
  const [layers, setLayers] = useState([]);
  const [selectedLayer, setSelectedLayer] = useState();

  async function getData() {
    let [divitionRes, layerRes] = await Promise.all([
      wsGetAll('base/layer-divition'),
      wsGetAll('base/layer'),
    ]);
    if (divitionRes.success) {
      setDivitions(divitionRes.data);
      if (divitionRes.data.length > 0) {
        setSelectedDivition(divitionRes.data[0]);
      }
    }

    if (layerRes.success) {
      setLayers(layerRes.data);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (layers.length === 0) return;
    let layer = layers.find((layer) => layer.divition.id === selectedDivition.id);
    setSelectedLayer(layer);
  }, [layers, selectedDivition]);

  const filteredLayers = useMemo(() => {
    if (layers.length === 0) return [];
    if (selectedDivition === undefined) return [];
    return layers.filter((layer) => layer.divition.id === selectedDivition.id);
  }, [layers, selectedDivition]);

  const filteredDivitions = useMemo(() => {
    if (divitions.length === 0) return [];
    return divitions.filter((divition) => !excludedDivitions.includes(divition.id));
  });

  return (
    <LayerContext.Provider
      value={{
        // Divisiones
        divitions,
        selectedDivition,
        setSelectedDivition,
        excludedDivitions,
        setExcludedDivitions,
        filteredDivitions,
        // Capas
        layers,
        selectedLayer,
        setSelectedLayer,
        filteredLayers,
      }}
    >
      {children}
    </LayerContext.Provider>
  );
};

const useLayerContext = () => useContext(LayerContext);
export default useLayerContext;
